<template>
  <div class="o-wrapper o-wrapper--huge c-wrapper">
    <vue-progress-bar></vue-progress-bar>
    <div class="c-wrapper--min-100vh">
      <header v-if="! hideHeader" class="c-header o-wrapper o-wrapper--huge js-header">
        <router-link :to="homepage" class="c-logo__link">
          <div class="c-logo"></div>
        </router-link>
        <div class="c-header__title-block u-push-1-of-5-at-medium u-3-of-4-at-medium">
          <router-link :to="homepage" class="c-header__home-link" v-if="showHome">
            {{$t('home')}}
          </router-link>
          <span v-if="showHome">&nbsp;&gt;&nbsp;</span>
          <h1 class="c-header__title" :title="headerTitle">
            {{headerTitle}}
          </h1>
        </div>

        <div class="c-header__user-actions">
          <clientSelectionStatus />
          <template v-if="!! user">
          <div class="c-header__user-menu" ref="userMenu">
            <button class="c-button c-button--ghost c-button--tiny c-button--icon"
                    v-on:click="userMenu = ! userMenu">
              <svg role="img" class="c-button__icon">
                <use xlink:href="images/user.svg"></use>
              </svg>
              <span :class="{ 'c-header__user--rotated': !! user }">▼</span>
            </button>
            <div v-if="userMenu" class="c-header__user-dropdown">
              <p class="c-header__username">{{ user.name }}</p>
              <sceRouteButton v-if="showUserProfile" :route="{ name: 'user.profile', params: {userId: user.id }}" label="Profile"/>
              <sceRouteButton v-if="showUserProfile" :route="{ name: 'user.organisations', params: {userId: user.id }}" label="Organisations"/>
              <a v-if="!isLocal" class="c-button c-button--menu" :href="newClientUrl"><span class="c-button__label">{{$t('interface.switchToNew')}}</span></a>
              <sceRouteButton :route="{ name: 'logout'}" label="Logout"/>
            </div>
          </div>

          <button v-if="showMenu" v-on:click="toggleFullscreen"
                  class="c-button c-button--ghost c-button--tiny c-button--icon c-header__fullscreen-button">
            <svg role="img" class="c-button__icon">
              <use v-if="!fullscreen" xlink:href="images/svg-symbols.svg#enter-fullscreen"></use>
              <use v-else xlink:href="images/svg-symbols.svg#exit-fullscreen"></use>
            </svg>
          </button>
          </template>
        </div>
      </header>
      <main class="c-main-wrapper o-layout o-layout--main">
        <div v-if="showMenu" class="c-sidebar o-layout__item" :class="{'c-sidebar--hidden-on-hover': fullscreen}">
          <router-view name="menu"></router-view>

          <div class="u-margin-top-medium u-padding-small">
            version: {{version}} <br/>
            <a href="https://www.scoreexpress.be/releases" target="_blank">{{ $t('versions') }}</a>
          </div>
        </div>
        <div class="c-main o-layout__item"
             :class="{'c-main--after-sidebar': showMenu, 'c-main--fullscreen': fullscreen}">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <modalSimple />
  </div>
</template>

<script>

export default {
  name: 'appLayout',
  components: {
    clientSelectionStatus: require('client/components/clientSelectionStatus.vue').default,
  },
  props: {
    'showMenu': {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      fullscreen: false,
      showHome: false,
      userMenu: false,
      homepage: null,
    }
  },
  computed: {
    event: function() {
      return this.$store.state.events.current
    },
    user: function () {
      return this.$store.state.user.instance;
    },
    newClientUrl: function() {
      return '/client/nuxt?return=' + encodeURIComponent(this.$route.fullPath)
    },
    isLocal: function() {
      return this.$store.state.environment.local
    },
    version: function() {
      return this.$store.state.environment.appVersion;
    },
    userHomepage: function() {
      return this.$store.state.user.homepage
    },
    showUserProfile: function() {
      return this.$store.state.user.roles.general !== 'event'
    },
    headerTitle: function() {
      return this.$store.state.environment.title
    },
    hideHeader: function() {
      return this.$route.meta.hideHeader
    }
  },
  watch: {
    $route: {
      handler: function() {
        this.showHome = false

        if (this.user) {
          let home = '/user'
          this.homepage = this.userHomepage

          switch (this.homepage.name) {
            case 'event.view':
              home = '/event'
              break
            case 'organisation.events':
              home = '/organisation'
              break
            case 'admin.events':
              home = '/admin'
              break
            case 'judge.events':
              home = '/judge'
              break
          }
          this.showHome = ! this.$route.path.startsWith(home)
        }
        else if (this.$store.state.environment.local) {
          this.homepage = { name: 'local.events' }
          this.showHome = true
        }
      },
      immediate: true
    },
  },
  mounted: function() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount: function() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleFullscreen: function (e) {
      this.fullscreen = ! this.fullscreen
      e.target.parentElement.blur()
    },
    handleClickOutside: function(event) {
      const ref = this.$refs.userMenu
      if (ref && !ref.contains(event.target)) {
        this.userMenu = false
      }
    }

  }
}
</script>

<style scoped lang="scss">
.userDrop {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.25rem;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  min-width: 200px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: start;
}

.userDrop__name {
  padding: 5px;
}

.rotated {
  transform: rotate(180deg);
  transition: transform 0.2s;
}

.c-button--menu {
  width: 100%;
  text-align: left;
}
</style>
